module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('strong', [_vm._v("Figures and Tables")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "6em"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic diagram of a boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler components")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical power plant effluents and emissions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple boiler plus combustion air heater")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple boiler with economizer and air heater")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler drums")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 1-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_09_ch1#fig1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example boiler P&ID with BMS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple feedback control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feedforward plus feedback control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cascade control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ratio control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ziegler Nichols tuning")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#tab2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 2-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuning terms/equations")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical control system responses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical output variable")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deviation between set point and process variable")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upset and return to recovery with reset")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upset and return to recovery with derivative action and reset")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2-11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_10_ch2#fig2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steady process variable with randomly varying load")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressure fired boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Block diagram of boiler control – furnace control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace pressure transmitters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace pressure control")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Functional diagram/symbol logic for furnace draft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace draft control. (Single-element feedback control of an induced draft fan.)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace draft control. (Feedforward-plus-feedback control of an induced draft fan.)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damper and fan speed control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damper and fan speed control-non-interacting method")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_11_ch3#fig3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variable speed fan characteristics – reduction in horsepower")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Block diagram of boiler control - drum level feedwater")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boiler drums/level measurement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indicated levels vs. drum pressure")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical drum level differential pressure transmitter connections")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gage glass drum level indication")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drum level transmitter")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple feedback control loop")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single element control action")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrink and swell")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single element control – drum level")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single element feedwater control (functional digram/symbols)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Single element feedwater control (ISA symbols)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two element feedwater control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Performance two element (ideal conditions)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-15")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Performance two element (effect of feedwater variation)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two element feedwater control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-17")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three element feedwater control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_12_ch4#fig4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P&ID for three element control using ISA symbols")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#tab5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 5-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coal Btu Values per Pound by State")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Direct firing system for pulverized coal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modified direct fired pulverized coal system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control system for a pulverized coal boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excess oxygen and carbon monoxide relationship at various loads for a gas-fired boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain grate stoker")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control scheme for a stoker boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_13_ch5#fig5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combustion control for cyclone-fired boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Block diagram of boiler control – fuel air control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mechanical positioning system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallel positioning with no fuel air measurement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuel follow air series metering system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air follow fuel series metering system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic parallel metering")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallel meter fuel flow interlock")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallel meter air flow interlock")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firing single fuel/cross limiting")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Output from flow transmitters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Characterization curve")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excess air vs. boiler load")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#tab6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 6-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationship of excess air to oxygen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dual fuel cross limiting control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Running fuel change, dual fuel O"), _c('sub', [_vm._v("2")]), _vm._v(" trim")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#tab6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 6-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_14_ch6#fig6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuel Btu values per pound by state")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Block diagram of boiler control – steam temperature control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical single element superheat control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical two element superheat control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical three element superheat control")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical superheater single-stage attemperator arrangement")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temperature measurement taken at outlet of intermediate superheater section")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_15_ch7#fig7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-element control for spray attemperator")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame detectors")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlock system for multiple burner boiler")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#tab8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 8-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NFPA table of shutdown requirements")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#tab8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 8-2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communicating startup permissives, shutdown, alarms and status for single boilers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#tab8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 8-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communicating startup permissives, shutdown, alarms and status for multiple boilers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example gas igniter")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example steam or air atomizing system light oil")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example main oil burner system mechanical atomizing")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example main gas burner system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of an oil burner steam atomizing system")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8-8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_16_ch8#fig8-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furnace Pressure Control")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#fig9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 9-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_17_ch9#fig9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controlling ammonia injection")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#fig10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10-1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781937560379_18_ch10#fig10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Typical flow characteristic curves")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-692b603a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781937560379_08_figtab.vue
// module id = 78
// module chunks = 0